import type { FaireProductEntity } from "../../entity_types/product";

export const p_xy6b7mt8hh: FaireProductEntity = {
  token: "p_xy6b7mt8hh",
  type: "product",
  name: "Fissure Control",
  brandToken: "b_63rejl12p8",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/809caaeba3fb1bd16af8c0d5ffc909f3dca7493fd75fa8dc7523f14dc8d31c8f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/215b8a2221710725643cde042776476d35eb970abdd5c6268ba42821b7111950.png",
    "https://cdn.faire.com/fastly/edf4793721622b23de5000e8a4227f70ce616d4a23e1a5ad8624577ae8a2678b.png",
    "https://cdn.faire.com/fastly/d15023c0fa57bd885932bc02b6b02acb7c9c20553daca732d7468c672950f6fb.jpeg",
    "https://cdn.faire.com/fastly/088a783c4fdc17e4c7a8917240f291744755627bd89cdd9f78ed7e7f6e98ccca.png",
    "https://cdn.faire.com/fastly/70ae901f5687171224d3386499fdbe8e3179b099fcfbb3c86e787f53b1833299.png",
    "https://cdn.faire.com/fastly/154c17206afc6c7de3e3c910869027d6d0604314378af6ed49a65e07ed9b6c59.png",
    "https://cdn.faire.com/fastly/69b7b97daaa1317adfa3c2d82b3fb19f49703981ae62ef227786f778918aae22.png",
    "https://cdn.faire.com/fastly/555476697b97c4db069e83f3741c0583449c710d0b260c42cb909be79c31155e.png",
    "https://cdn.faire.com/fastly/f1018f6cd0ee1f76565bf1b8b82d297ad9c405b8ab28c775be7e308e3f1fb149.png",
    "https://cdn.faire.com/fastly/64663f623466445433c2a577da38f1aa38140b26d913917041298576ad75db31.png"
  ],
  priceDollars: 17.29,
  description: "Forces of Nature Fissure Control is a powerful, plant-based solution to naturally relieve the pain, burning, and discomfort of anal fissures. It is made with organic homeopathic medicines, including Calendula Officinalis (Marigold) and Hamamelis Virginiana (Witch Hazel), that are not only known for their anti-inflammatory properties but work with your body to promote skin repair and improve blood circulation. Blended with pure essential oils, like German Chamomile and Helichrysum, the oil also nourishes and soothes your skin. The oil-based formula is gentle to apply and absorbs quickly rather than using a cream that can be painful to spread and rub in. Unlike conventional creams that can contain harsh chemicals or synthetic fillers, this formula uses only certified organic ingredients to calm irritation, reduce inflammation, and uniquely support tissue repair.\n\nCertified Organic, Non-GMO Project Verified, and Leaping Bunny certified, Fissure Control represents our high standard for clean skin care. Choose Fissure Control to get fast pain relief and prompt your body to begin healing naturally.\n",
  tags: [],
  msrpDollars: 34.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:53.968Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
